import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceClientService } from '../service-client.service';
import { Response } from 'src/app/models/user';
import { AiComposerGuideline } from 'src/app/models/ai-composer';

@Injectable({
  providedIn: 'root',
})
export class AiComposerService {
  constructor(private serviceClientService: ServiceClientService) {}

  getNarrativeTemplates(params?: HttpParams): Observable<Response<AiComposerGuideline[]>> {
    return this.serviceClientService.get(
      environment.endPoints.getAiComposerNarrativeTemplates,
      params,
    );
  }

  createNarrativeTemplate(payload: Partial<AiComposerGuideline>): Observable<Response<AiComposerGuideline>> {
    return this.serviceClientService.post(
      environment.endPoints.createAiComposerNarrativeTemplate,
      payload,
    );
  }

  updateNarrativeTemplate(id: string, payload: Partial<AiComposerGuideline>): Observable<Response<AiComposerGuideline>> {
    return this.serviceClientService.post(
      `${environment.endPoints.updateAiComposerNarrativeTemplate}/${id}`,
      payload,
    );
  }

  deleteNarrativeTemplate(id: string): Observable<Response<any>> {
    return this.serviceClientService.delete(
      `${environment.endPoints.deleteAiComposerNarrativeTemplate}/${id}`,
    );
  }

  getNarrativeTemplateHistory(id: string): Observable<any> {
    return this.serviceClientService.get(
      `${environment.endPoints.getAiComposerNarrativeTemplateHistory}/${id}/history`,
    );
  }

  getNotesTemplates(params?: HttpParams): Observable<Response<AiComposerGuideline[]>> {
    return this.serviceClientService.get(
      environment.endPoints.getAiComposerNotesTemplates,
      params,
    );
  }

  createNotesTemplate(payload: Partial<AiComposerGuideline>): Observable<Response<AiComposerGuideline>> {
    return this.serviceClientService.post(
      environment.endPoints.createAiComposerNotesTemplate,
      payload,
    );
  }

  updateNotesTemplate(id: string, payload: Partial<AiComposerGuideline>): Observable<Response<AiComposerGuideline>> {
    return this.serviceClientService.post(
      `${environment.endPoints.updateAiComposerNotesTemplate}/${id}`,
      payload,
    );
  }

  deleteNotesTemplate(id: string): Observable<Response<any>> {
    return this.serviceClientService.delete(
      `${environment.endPoints.deleteAiComposerNotesTemplate}/${id}`,
    );
  }

  getNotesTemplateHistory(id: string): Observable<any> {
    return this.serviceClientService.get(
      `${environment.endPoints.getAiComposerNotesTemplateHistory}/${id}/history`,
    );
  }

  getVisitTypeMetadata(): Observable<Response<any>> {
    return this.serviceClientService.get(environment.endPoints.getAiComposerVisitTypes);
  }
}

